import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CHOOSE: "Velg",
      ENTER_YOUR_OWN_AMOUNT: "Skriv inn ditt eget beløp",
    },
    se: {
      CHOOSE: "Välj",
      ENTER_YOUR_OWN_AMOUNT: "Skriv in ett valfritt belopp",
    },
    dk: {
      CHOOSE: "Vælg",
      ENTER_YOUR_OWN_AMOUNT: "Indtast et andet beløb",
    },
  } as const
)[language];
